// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Vccwh","option":"styles_option__1Psiq","selected":"styles_selected__3V-mw"};